import { fetchJSON } from '@ratehub/base-ui';

/**
 * Fetch deposit products according to options
 * @param {Object} options
 * @param {string} options.province - Province code
 * @param {string} options.language - Language code
 * @param {Object[]} options.products - An array of requested products ordered by priority
 * @param {string} apiRoute
 * @return {Promise<Object>}
 */
export default async function fetchDeposit(options, apiRoute) {
    const params = {
        province: options.province,
        language: options.language,
        placements: options.products,
    };

    return await fetchJSON({
        url: apiRoute,
        options: {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify(params),
        },
    }, 'fetchDeposit');
}
